import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=63736c7e&"
import script from "./order-card.vue?vue&type=script&lang=js&"
export * from "./order-card.vue?vue&type=script&lang=js&"
import style0 from "./order-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63736c7e')) {
      api.createRecord('63736c7e', component.options)
    } else {
      api.reload('63736c7e', component.options)
    }
    module.hot.accept("./order-card.vue?vue&type=template&id=63736c7e&", function () {
      api.rerender('63736c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/order-card/order-card.vue"
export default component.exports